var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    ref: "headerRef",
    class: _vm.$style.Header,
    attrs: {
      "role": "banner"
    }
  }, [_c('div', {
    class: _vm.$style.leftSide
  }, [_c('NuxtLink', {
    class: _vm.$style.logoLink,
    attrs: {
      "to": _setup.ROUTE_PATHS.index,
      "aria-label": "Главная"
    }
  }, [_c(_setup.TheLogo)], 1)], 1), _vm._v(" "), _c('nav', {
    class: _vm.$style.rightSide,
    attrs: {
      "aria-label": "Дополнительная"
    }
  }, [_setup.screen.isDesktop ? [_setup.hasSupportFlag ? _c(_setup.NavButton, {
    attrs: {
      "icon": "i-service-gradient",
      "text": "Техническая помощь"
    },
    nativeOn: {
      "click": function click($event) {
        return _setup.handleSupport.apply(null, arguments);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c(_setup.ContactsButton), _vm._v(" "), _c(_setup.CertifiedPartner)] : _vm._e(), _vm._v(" "), _setup.isHeaderNew && !_setup.isAggregator ? _c(_setup.HeaderLoyaltyButton) : _vm._e(), _vm._v(" "), _setup.screen.isDesktop ? _c(_setup.HeaderNotificationsButton, {
    attrs: {
      "header-height": _setup.headerHeight
    }
  }) : _vm._e(), _vm._v(" "), _setup.screen.isTabletOrDesktop ? _c(_setup.HeaderProfileButton, {
    scopedSlots: _vm._u([!_setup.isHeaderNew ? {
      key: "menu-extra",
      fn: function fn(_ref) {
        var onItemClick = _ref.onItemClick;
        return [_c(_setup.LoyaltyMenuItem, {
          on: {
            "click": onItemClick
          }
        })];
      }
    } : null], null, true)
  }) : _vm._e(), _vm._v(" "), _setup.screen.isMobileOrTablet ? _c(_setup.HeaderButtonMenu, {
    class: _vm.$style.menuButton,
    nativeOn: {
      "click": function click($event) {
        return _setup.emit('menu-button-click');
      }
    }
  }) : _vm._e()], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };